import { render, staticRenderFns } from "./Facemask.vue?vue&type=template&id=6f729552&scoped=true&"
import script from "./Facemask.vue?vue&type=script&lang=js&"
export * from "./Facemask.vue?vue&type=script&lang=js&"
import style0 from "./Facemask.vue?vue&type=style&index=0&id=6f729552&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f729552",
  null
  
)

export default component.exports